import type { UserRow } from './UsersTable'

/**
 * Identidade de linha da listagem de usuários (fonte única).
 *
 * A lista mistura duas coisas: usuários reais (`users.id`) e cadastros
 * pendentes de aprovação, que o backend anexa com **`id: null`** e o id real em
 * `registration_id`. Usar `id` como chave/seleção para os pendentes fazia
 * `null === null` casar entre linhas diferentes: marcar um pendente marcava
 * todos, clicar em um destacava todos, e `key={id}` colidia no React.
 */
type RowIdentity = Pick<UserRow, 'id' | 'type' | 'status' | 'registration_id' | 'email'>

export function isPendingRow(row: Pick<UserRow, 'type' | 'status'>): boolean {
  return row.type === 'pending_registration' || row.status === 'pending_approval'
}

export function rowKey(row: RowIdentity): string {
  if (isPendingRow(row)) return `reg:${row.registration_id ?? row.email}`
  return `user:${row.id}`
}

/**
 * Ids selecionáveis em massa: só usuários reais. Ativar/desativar/excluir não
 * se aplica a um cadastro pendente (esse se aprova ou se rejeita no drawer), e
 * deixá-lo entrar na seleção disparava `PUT /v1/users/null` → 422.
 */
export function selectableIds(rows: RowIdentity[]): number[] {
  return rows.filter((r) => !isPendingRow(r)).map((r) => r.id)
}
